module.exports = __webpack_public_path__ + "img/jun.e7863cf0.png";